import { render, staticRenderFns } from "./diasLonchera.vue?vue&type=template&id=46515ce4&"
import script from "./diasLonchera.vue?vue&type=script&lang=js&"
export * from "./diasLonchera.vue?vue&type=script&lang=js&"
import style0 from "./diasLonchera.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports